import { render } from "./TopBackground.vue?vue&type=template&id=4362a9f0&scoped=true"
const script = {}

import "./TopBackground.vue?vue&type=style&index=0&id=4362a9f0&scoped=true&lang=css"

import exportComponent from "/Users/ken/Documents/Workspace/junipop/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.47_webpack@5.79.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4362a9f0"]])

export default __exports__